import { FC, memo } from 'react';

import { CustomListItem } from 'application/components/CustomList';

import { SberIDReauth } from '@features/SberIDReauth';

import useSberBusinessOnline from '../../model/useSberBusinessOnline';
import SberBusinessOnlineActions from '../SberBusinessOnlineActions/SberBusinessOnlineActions';
import SberBusinessOnlineContent from '../SberBusinessOnlineContent/SberBusinessOnlineContent';
import { SberBusinessOnlineProps } from './sberBusinessOnlineProps';

import styles from './SberBusinessOnline.module.scss';

const SberBusinessOnline: FC<SberBusinessOnlineProps> = ({
  paymentMethodId,
  isSelected,
  switcherHidden,
  licensesCount,
  hasTrialLicenses,
  hasInactiveLicenses,
  hasActiveLicenses,
  nonRenewableLicenses,
  unpaidLicenses,
  setSelectedItemId,
}) => {
  const { sberAuthButtonVisible } = useSberBusinessOnline({
    licensesCount,
    hasTrialLicenses,
    hasInactiveLicenses,
    hasActiveLicenses,
    nonRenewableLicenses,
    unpaidLicenses,
  });

  return (
    <div className={styles.container}>
      <CustomListItem
        id={paymentMethodId}
        elementId={`payment_method_${paymentMethodId}`}
        contentId="sber_payment"
        isSelected={isSelected}
        switcherHidden={switcherHidden}
        onChange={() => setSelectedItemId(paymentMethodId)}
        content={<SberBusinessOnlineContent />}
        small
        footer={
          <>
            <SberBusinessOnlineActions />
            <div className={styles.sberId}>{sberAuthButtonVisible && <SberIDReauth />}</div>
          </>
        }
      />
    </div>
  );
};

export default memo(SberBusinessOnline);
